import { ReportType } from '@wellesley/openapi'
import {
  Bug,
  Ban,
  BookUser,
  ShieldBan,
  ThumbsDown,
  BookOpenText,
} from 'lucide-react'

export type REPORT_STEP =
  | 'list'
  | 'not_fan'
  | 'server_rules'
  | 'group_rules'
  | 'spam'
  | 'against_law'
  | 'another_problem'

const iconOptions = {
  size: 20,
  color: 'var(--gray-900)',
}

export type ReportOption = {
  step: REPORT_STEP
  title: string
  description: string
  icon: React.ReactNode
  type?: ReportType
}

export const getReportOptions = (hasGroupRules: boolean): ReportOption[] =>
  [
    {
      step: 'not_fan' as REPORT_STEP,
      title: 'I’m not a fan',
      description: 'This is not something you would prefer to see',
      icon: <ThumbsDown {...iconOptions} />,
    },
    {
      step: 'server_rules' as REPORT_STEP,
      title: 'Server rules violation',
      description: 'You know it goes against certain established server rules',
      icon: <BookOpenText {...iconOptions} />,
      type: 'SERVER_RULES' as ReportType,
    },
    hasGroupRules && {
      step: 'group_rules' as REPORT_STEP,
      title: 'It breaks group rules',
      description: 'You know it goes against group rules',
      icon: <BookUser {...iconOptions} />,
      type: 'GROUP_RULES' as ReportType,
    },
    {
      step: 'spam' as REPORT_STEP,
      title: "It's spammy",
      description: 'Harmful links, false interactions, or repeated responses',
      icon: <Bug {...iconOptions} />,
      type: 'SPAM' as ReportType,
    },
    {
      step: 'against_law' as REPORT_STEP,
      title: "It's against the law",
      description:
        "You think it breaches legal regulations in your or the server's country",
      icon: <ShieldBan {...iconOptions} />,
      type: 'ILLEGAL' as ReportType,
    },
    {
      step: 'another_problem' as REPORT_STEP,
      title: 'Other',
      description: 'The concern doesn’t match any of the other options',
      icon: <Ban {...iconOptions} />,
      type: 'OTHER' as ReportType,
    },
  ].filter(Boolean) as ReportOption[]
